export class CatalogService {

    constructor(catalogRepository) {
        this.catalogRepository = catalogRepository;
    }

    all() {
        return this.catalogRepository.all();
    }

    categories() {
        return this.catalogRepository.categories();
    }

    getItemsByCategory(categoryId) {
        return this.catalogRepository.getItemsByCategory(categoryId);
    }

    create(category, description, percentage) {
        return this.catalogRepository.create(category, description, percentage);
    }
}
